export const GET_ACCOUNT_INFO = '@ACCOUNT_INFO/GET_ACCOUNT_INFO'
export const UPDATE_ACCOUNT_INFO_BASIC = '@ACCOUNT_INFO/UPDATE_ACCOUNT_INFO_BASIC'
export const UPDATE_ACCOUNT_INFO_BUSINESS = '@ACCOUNT_INFO/UPDATE_ACCOUNT_INFO_BUSINESS'
